import { Guid } from "guid-typescript";
import { IMessage } from "../../../IMessage";

//Generated code, do not modify

export class GetEventOverviewQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetEventOverviewQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/events/${this.id.toString()}/overview`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}